import { computed, inject } from 'vue';
import { useI18n } from 'vue-i18n';

export const LANDING_KEY = Symbol('resellerLanding');

const NUMBER_LOCALES = { pt_BR: 'pt-BR', en: 'en-US', es: 'es-419' };

const isExternal = href => /^https?:\/\//.test(href || '');
const WHATSAPP_URL =
  /^https?:\/\/(wa\.me|api\.whatsapp\.com|(www\.)?whatsapp\.com)\//i;

export function useLanding() {
  const landing = inject(LANDING_KEY);
  const { t: translate, tm, rt, locale } = useI18n();
  const globals = { brand: landing.brand.name, domain: landing.domain };

  const t = (key, params = {}) => translate(key, { ...globals, ...params });

  const resolve = value => {
    if (Array.isArray(value)) return value.map(resolve);
    if (typeof value === 'string' || typeof value === 'function') {
      return rt(value, globals);
    }
    if (value && typeof value === 'object') {
      return Object.fromEntries(
        Object.entries(value).map(([key, item]) => [key, resolve(item)])
      );
    }
    return value;
  };

  const list = key => resolve(tm(key));
  const numberLocale = computed(() => NUMBER_LOCALES[locale.value]);

  const sellsPlans = landing.cta.mode !== 'link';
  // pricingUrl: a tabela da própria página ou, nas páginas sem preços, o
  // cadastro/link ou a tabela da home.
  const ctaHref = sellsPlans ? landing.cta.pricingUrl : landing.cta.url;
  const planHref = landing.cta.signupUrl || ctaHref;
  // contactUrl: páginas que vendem um serviço do revendedor levam ao link dele.
  const primaryHref =
    landing.cta.contactUrl || landing.cta.signupUrl || ctaHref;
  const ctaIsWhatsapp = WHATSAPP_URL.test(primaryHref || '');
  const checkoutPath = landing.cta.checkoutPath;
  const csrfToken = document
    .querySelector('meta[name="csrf-token"]')
    ?.getAttribute('content');
  const linkTarget = href =>
    isExternal(href) ? { target: '_blank', rel: 'noopener noreferrer' } : {};

  return {
    landing,
    locale,
    numberLocale,
    t,
    list,
    ctaHref,
    planHref,
    primaryHref,
    ctaIsWhatsapp,
    checkoutPath,
    csrfToken,
    linkTarget,
  };
}
